import { useEffect, useRef } from 'react';

export default function AdminOtpActionModal({
  open,
  title = '관리자 OTP 확인',
  description = 'Google Authenticator에 표시되는 현재 6자리 숫자를 입력해 주세요.',
  value,
  error,
  working,
  onChange,
  onClose,
  onSubmit,
}) {
  const inputRef = useRef(null);

  useEffect(() => {
    if (open) inputRef.current?.focus();
  }, [open]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[4000] flex items-center justify-center bg-black/45 p-4" onClick={onClose}>
      <div className="w-full max-w-md rounded-2xl bg-white p-5 shadow-2xl" onClick={(event) => event.stopPropagation()}>
        <h2 className="text-lg font-bold text-[#191f28]">{title}</h2>
        <p className="mt-2 text-sm leading-6 text-[#6b7684]">{description}</p>
        <input
          ref={inputRef}
          value={value}
          onChange={(event) => onChange(event.target.value.replace(/\D/g, '').slice(0, 6))}
          onKeyDown={(event) => { if (event.key === 'Enter' && value.length === 6 && !working) onSubmit(); }}
          inputMode="numeric"
          autoComplete="one-time-code"
          maxLength={6}
          placeholder="000000"
          aria-label="관리자 OTP 6자리"
          className="mt-4 w-full rounded-xl border border-[#dfe3e8] px-4 py-3 text-center text-2xl tracking-[0.45em] outline-none focus:border-[var(--brand-primary)]"
        />
        {error && <p className="mt-2 text-sm text-red-600">{error}</p>}
        <div className="mt-5 flex gap-2">
          <button type="button" disabled={working} onClick={onClose} className="flex-1 rounded-xl border border-[#dfe3e8] py-3 font-semibold disabled:opacity-40">취소</button>
          <button type="button" disabled={working || value.length !== 6} onClick={onSubmit} className="flex-1 rounded-xl bg-[#191f28] py-3 font-semibold text-white disabled:opacity-40">
            {working ? '처리 중...' : '확인'}
          </button>
        </div>
      </div>
    </div>
  );
}
